import React from 'react';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import Alert from '../../../components/alert';
import { IGetCartData } from '../../../actions/get-cart.action';

interface MessageViewProps {
    cartData: IGetCartData;
    resources: ILxsCreateOrderResources;
    processStarted: boolean;
    isReordering: boolean;
    hasNoReorderItems: boolean;
    loadSoldTos: () => void;
    setCartData: () => void;
    setResetAddressFlyout: (value: boolean) => void;
}

const messageView = ({
    cartData,
    resources,
    processStarted,
    isReordering,
    hasNoReorderItems,
    loadSoldTos,
    setCartData,
    setResetAddressFlyout
}: MessageViewProps) => {
    return (
        <div className='row'>
            <div className='col-12'>
                {hasNoReorderItems ? (
                    <>
                        <Alert message={resources.createOrderReorderingNoItems} type='info' iconSize={1} />
                        <p
                            className='msc-alert__explanation'
                            dangerouslySetInnerHTML={{ __html: resources.createOrderReorderingMessageNoItems }}
                        />
                        <div className='msc-form__button-group'>
                            <button className='msc-cta__primary' onClick={() => loadSoldTos()}>
                                {resources.createOrderCartExistsRestart}
                            </button>
                        </div>
                    </>
                ) : isReordering ? (
                    <>
                        <Alert message={resources.createOrderReordering} type='info' iconSize={1} />
                        <p
                            className='msc-alert__explanation'
                            dangerouslySetInnerHTML={{ __html: resources.createOrderReorderingMessage }}
                        />
                    </>
                ) : !!cartData && cartData['@odata.context'] && !cartData.SoldTo && !processStarted ? (
                    <>
                        <Alert message={resources.createOrderExistingDataInvalid} type='danger' iconSize={1} />
                        <p
                            className='msc-alert__explanation'
                            dangerouslySetInnerHTML={{ __html: resources.createOrderExistingDataInvalidMessage }}
                        />
                        <div className='msc-form__button-group'>
                            <button className='msc-cta__primary' onClick={() => loadSoldTos()}>
                                {resources.createOrderCartExistsRestart}
                            </button>
                        </div>
                    </>
                ) : !!cartData && !!cartData['@odata.context'] && !processStarted ? (
                    <>
                        <Alert message={resources.createOrderCartExistsHint} type='warning' iconSize={1} />
                        <p
                            className='msc-alert__explanation'
                            dangerouslySetInnerHTML={{ __html: resources.createOrderCartExistsExplanation }}
                        />
                        <div className='msc-form__button-group'>
                            <button
                                className='msc-cta__primary'
                                onClick={() => {
                                    setCartData();
                                    setResetAddressFlyout(true);
                                }}
                            >
                                {resources.createOrderCartExistsResume}
                            </button>
                            <button
                                className='msc-cta__primary'
                                onClick={() => {
                                    loadSoldTos();
                                    setResetAddressFlyout(true);
                                }}
                            >
                                {resources.createOrderCartExistsRestart}
                            </button>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default messageView;
